import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { fundraisingService } from '../../services/fundraisingService';

export const useSaveFpgAssets = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async payload => {
      const response = await fundraisingService.saveFpgAssets(payload);
      const { status, data } = response;

      if (status === 200) {
        await Promise.all([
          queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.fundraising.status] }),
          queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.fundraising.status_by_id] }),
        ]);
        return data;
      }
    },
  });
};
